export const SCORING_RESULTS_REPORT_ENTRIES_LOG_MESSAGES = {
  NOT_FOUND: 'No records were found',
};


// WEBPACK FOOTER //
// ./src/features/reports/constants/scoringResultsReportEntriesMessages.js